import { useState, useRef, useEffect } from "react";
// ===================== CORE VALUES - Image with scroll expand (like Featured Project) =====================
export const CoreValuesImageSection = () => {
  const imgRef = useRef(null);
  const sectionRef = useRef(null);

  useEffect(() => {
    let raf;
    const update = () => {
      if (!imgRef.current || !sectionRef.current) return;
      const rect = sectionRef.current.getBoundingClientRect();
      const vh = window.innerHeight;
      const progress = Math.max(0, Math.min(1, 1 - (rect.top / (vh * 0.5))));
      const scale = 0.82 + progress * 0.18;
      const radius = 24 - progress * 24;
      imgRef.current.style.transform = `scale(${scale})`;
      imgRef.current.style.borderRadius = `${radius}px`;
    };
    const onScroll = () => { raf = requestAnimationFrame(update); };
    window.addEventListener("scroll", onScroll, { passive: true });
    update();
    return () => { window.removeEventListener("scroll", onScroll); cancelAnimationFrame(raf); };
  }, []);

  return (
    <section ref={sectionRef} className="pt-0 pb-20 lg:pb-32 bg-white" data-testid="v13-core-values-section">
      <div ref={imgRef} className="w-full overflow-hidden will-change-transform" style={{ transform: "scale(0.82)", borderRadius: "24px" }}>
        <img src="/gillco-core-values.png" alt="Gillco Core Values" className="w-full h-auto object-contain" />
      </div>
    </section>
  );
};

